import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import newcategory from "../assets/categories/newcategory.png";

import Footer from "../components/Footer";

function Categories() {
    const [categories, setCategories] = useState([]);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;

    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getCategories/JAPAN_ACCESORIES`);
                if (!response.ok) {
                    throw new Error("Failed to fetch categories");
                }
                const data = await response.json();
                // Assuming data is an array of objects with Id and Name properties
                const sortedCategories = sortCategories(data);
                setCategories(sortedCategories);
            } catch (error) {
                console.error("Error fetching categories:", error);
            }
        };

        fetchCategories();
    }, [apiBaseUrl]);

    const home = async () => {
        navigate("/home");
    };

    const sortCategories = (data) => {
        // Assuming "NEW ARRIVAL" and "OTHER ACCESSORIES" are specific names in the category list
        const newArrival = data.find((category) => category.Name === "NEW ARRIVAL");
        const otherAccessories = data.find((category) => category.Name === "OTHER ACCESSORIES");
        const remainingCategories = data.filter(
            (category) => category.Name !== "NEW ARRIVAL" && category.Name !== "OTHER ACCESSORIES"
        );

        return [newArrival, ...remainingCategories, otherAccessories].filter(Boolean);
    };

    const items = (id, Name) => {
        navigate("/items", { state: { categoryId: id, Name, category: "CATEGORIES" } });
    };

    return (
        <div className="h-auto flex flex-col  bg-[#F7F7F7]">
            <div className="sticky top-0 z-50">
                <Navbar />
            </div>
            <div className="h-[5vh] w-full mt-[1%]  flex items-center px-[7%] text-sm font-[500] text-[#605F5F]">
                <span className="cursor-pointer text-sm font-[500] text-[#605F5F]" onClick={home}>
                    HOME
                </span>{" "}
                &nbsp;{">"} CATEGORIES
            </div>
            <div className="w-full h-auto  flex flex-col justify-center items-center mt-[4%] lg:px-[7%] px-[2%]">
                <div className="grid  grid-cols-2  md:grid-cols-4 lg:grid-cols-5  w-full  gap-7 ">
                    {categories.map((category) => (
                        <div
                            key={category.Id}
                            onClick={() => items(category.Id, category.Name, "CATEGORIES")}
                            className="
                            lg:h-[220px] md:h-[200px] h-[160px] 
                            lg:w-[220px] md:w-[200px] w-[160px] 
                            flex flex-col justify-center items-center  gap-[5%]"
                        >
                            <div
                                id="category-div"
                                className="w-[80%]  h-[80%] bg-[#EEEEEE] cursor-pointer rounded-[50%] flex  justify-center items-center overflow-hidden"
                            >
                                <img
                                    className="category-image"
                                    src={`${apiLocalUrl}/category-image/${category.Id}`}
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = newcategory;
                                    }}
                                    alt={category.Name}
                                    style={{ width: "80%", height: "80%", borderRadius: "50%", objectFit: "fill" }}
                                />
                            </div>
                            <h2
                                className="lg:text-lg md:text-base sm:text-sm text-xs font-display font-[700] flex  justify-center items-center tracking-wide"
                                style={{ whiteSpace: "nowrap" }}
                            >
                                {category.Name}
                            </h2>
                            <style jsx>{`
                                .category-image {
                                    transition: transform 0.3s ease;
                                }

                                .category-image:hover {
                                    transform: scale(1.3);
                                }
                                #category-div:hover {
                                    background-color: #bb002d;
                                }
                            `}</style>
                        </div>
                    ))}
                </div>
            </div>
            <div className="mt-[7%]">
                <Footer />
            </div>
        </div>
    );
}

export default Categories;
